// extracted by mini-css-extract-plugin
export default {"header":"AuthHeader_header__lwe2i"};